import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.167 4.623l3.81-3.81A.385.385 0 008.433.27l-3.81 3.81L.813.27A.385.385 0 00.27.814l3.81 3.81L.27 8.432a.385.385 0 00.544.544l3.81-3.81 3.809 3.81a.385.385 0 00.544-.544l-3.81-3.81z" fill="#666" fillRule="evenodd" /></svg>;